// src/App.jsx
import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ThemeProvider from './contexts/ThemeContext';
import { TenantProvider } from './contexts/TenantContext';
import { ModuleProvider } from './contexts/ModuleContext';
import './styles/dark-mode.css';

import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import SolicitacaoTeste from './pages/SolicitacaoTeste/SolicitacaoTeste';
import Dashboard from './pages/Dashboard';
import FluxoErp from './pages/FluxoErp/FluxoErp';
import ProtectedRoute from './components/ProtectedRoute';
import AssistenteIa from './components/AssistenteIa';
import Sidebar from './components/Sidebar';
import GlobalBackNavigation from './components/GlobalBackNavigation';
import AtualizacoesModal from './components/AtualizacoesModal';

import UsuarioList from './pages/Usuarios/UsuarioList';
import UsuarioForm from './pages/Usuarios/UsuarioForm';
import ClienteList from './pages/Cliente/ClienteList';
import ClienteForm from './pages/Cliente/ClienteForm';
import FornecedorList from './pages/Fornecedor/FornecedorList';
import FornecedorForm from './pages/Fornecedor/FornecedorForm';
import TransportadoraList from './pages/transportadoras/TransportadoraList';
import TransportadoraForm from './pages/transportadoras/TransportadoraForm';
import CategoriaFinanceiraList from './pages/CategoriaFinanceira/CategoriaFinanceiraList';
import CategoriaFinanceiraForm from './pages/CategoriaFinanceira/CategoriaFinanceiraForm';

import AgricultorList from './pages/Agricultores/AgricultorList';
import AgricultorForm from './pages/Agricultores/AgricultorForm';
import PropriedadeList from './pages/Propriedade/PropriedadeList';
import PropriedadeForm from './pages/Propriedade/PropriedadeForm';
import MapaFazenda from './pages/MapaFazenda/MapaFazenda';
import TalhaoList from './pages/Talhao/TalhaoList';
import TalhaoForm from './pages/Talhao/TalhaoForm';
import SafraList from './pages/Safras/SafraList';
import SafraForm from './pages/Safras/SafraForm';
import PlantioList from './pages/Plantio/PlantioList';
import InsumoList from './pages/Insumos/InsumoList';
import InsumoForm from './pages/Insumos/InsumoForm';
import CompraInsumos from './pages/CompraInsumos/CompraInsumos';
import AplicacaoInsumoList from './pages/AplicacoesInsumo/AplicacaoInsumoList';
import AplicacaoInsumoForm from './pages/AplicacoesInsumo/AplicacaoInsumoForm';
import FluxoPlantio from './pages/FluxoPlantio/FluxoPlantio';
import Maquinas from './pages/Maquinas/Maquinas';
import OperacaoCampoList from './pages/OperacoesCampo/OperacaoCampoList';
import OperacaoCampoForm from './pages/OperacoesCampo/OperacaoCampoForm';
import ColheitaList from './pages/Colheitas/ColheitaList';
import ColheitaForm from './pages/Colheitas/ColheitaForm';
import ProducaoAgricola from './pages/ProducaoAgricola/ProducaoAgricola';
import ConfiguracaoFiscalProduto from './pages/ProducaoAgricola/ConfiguracaoFiscalProduto';
import RomaneioSafraList from './pages/RomaneioSafra/RomaneioSafraList';
import RomaneioSafraForm from './pages/RomaneioSafra/RomaneioSafraForm';
import FechamentoSafra from './pages/FechamentoSafra/FechamentoSafra';
import PecuariaDashboard from './pages/Pecuaria/PecuariaDashboard';

import ReceitaList from './pages/Receita/ReceitaList';
import DespesaList from './pages/Despesa/DespesaList';
import LancamentoFinanceiroForm from './pages/LancamentoFinanceiro/LancamentoFinanceiroForm';
import ContasPagarReceber from './pages/ContasPagarReceber/ContasPagarReceber';
import ExportacaoBancaria from './pages/Financeiro/ExportacaoBancaria';
import ControleFinanceiroAgro from './pages/Financeiro/ControleFinanceiroAgro';
import NotaFiscalList from './pages/NotaFiscal/NotaFiscalList';
import NotaFiscalForm from './pages/NotaFiscal/NotaFiscalForm';
import NotaFiscalDetalhe from './pages/NotaFiscal/NotaFiscalDetalhe';
import CteEmissao from './pages/Cte/CteEmissao';
import CertificadoDigital from './pages/Config/CertificadoDigital';
import OnboardingInicial from './pages/Onboarding/OnboardingInicial';
import AssinaturasClientes from './pages/Assinaturas/AssinaturasClientes';
import Auditoria from './pages/Auditoria/Auditoria';
import Novidades from './pages/Novidades/Novidades';
import NovidadesAdmin from './pages/Novidades/NovidadesAdmin';
import FerramentasGestao from './pages/FerramentasGestao/FerramentasGestao';
import ImportacaoDados from './pages/ImportacaoDados/ImportacaoDados';

import RelatorioFinanceiro from './pages/Relatorios/RelatorioFinanceiro';
import RelatorioIntegrado from './pages/Relatorios/RelatorioIntegrado';
import RelAgriAgricultor from './pages/Relatorios/RelAgriAgricultor';
import RelAgriPropriedade from './pages/Relatorios/RelAgriPropriedade';
import RelOperacaoCampo from './pages/Relatorios/RelOperacaoCampo';
import RelColheita from './pages/Relatorios/RelColheita';
import RelAplicacaoInsumo from './pages/Relatorios/RelAplicacaoInsumo';

const AppShell = ({ children }) => (
  <div className="app-shell">
    <Sidebar />
    <main className="app-shell-content">
      {children}
    </main>
  </div>
);

const Protected = ({ children }) => (
  <ProtectedRoute>
    <AppShell>{children}</AppShell>
  </ProtectedRoute>
);

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <TenantProvider>
          <ModuleProvider>
          <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <GlobalBackNavigation />
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/solicitar-teste" element={<SolicitacaoTeste />} />

              <Route path="/menu" element={<Protected><Dashboard /></Protected>} />
              <Route path="/onboarding-inicial" element={<Protected><OnboardingInicial /></Protected>} />
              <Route path="/fluxo-erp" element={<Protected><FluxoErp /></Protected>} />

              <Route path="/usuarios" element={<Protected><UsuarioList /></Protected>} />
              <Route path="/usuarios/create" element={<Protected><UsuarioForm /></Protected>} />
              <Route path="/usuarios/edit/:id" element={<Protected><UsuarioForm /></Protected>} />

              <Route path="/cliente" element={<Protected><ClienteList /></Protected>} />
              <Route path="/cliente/create" element={<Protected><ClienteForm /></Protected>} />
              <Route path="/cliente/:id" element={<Protected><ClienteForm /></Protected>} />
              <Route path="/fornecedor" element={<Protected><FornecedorList /></Protected>} />
              <Route path="/fornecedor/create" element={<Protected><FornecedorForm /></Protected>} />
              <Route path="/fornecedor/:id" element={<Protected><FornecedorForm /></Protected>} />
              <Route path="/transportadoras" element={<Protected><TransportadoraList /></Protected>} />
              <Route path="/transportadoras/novo" element={<Protected><TransportadoraForm /></Protected>} />
              <Route path="/transportadoras/editar/:id" element={<Protected><TransportadoraForm /></Protected>} />
              <Route path="/categoriafinanceira" element={<Protected><CategoriaFinanceiraList /></Protected>} />
              <Route path="/categoriafinanceira/create" element={<Protected><CategoriaFinanceiraForm /></Protected>} />
              <Route path="/categoriafinanceira/editar/:id" element={<Protected><CategoriaFinanceiraForm /></Protected>} />

              <Route path="/agricultores" element={<Protected><AgricultorList /></Protected>} />
              <Route path="/agricultores/novo" element={<Protected><AgricultorForm /></Protected>} />
              <Route path="/agricultores/editar/:id" element={<Protected><AgricultorForm /></Protected>} />
              <Route path="/propriedades" element={<Protected><PropriedadeList /></Protected>} />
              <Route path="/propriedades/novo" element={<Protected><PropriedadeForm /></Protected>} />
              <Route path="/propriedades/editar/:id" element={<Protected><PropriedadeForm /></Protected>} />
              <Route path="/mapa-fazenda" element={<Protected><MapaFazenda /></Protected>} />
              <Route path="/talhoes" element={<Protected><TalhaoList /></Protected>} />
              <Route path="/talhoes/novo" element={<Protected><TalhaoForm /></Protected>} />
              <Route path="/talhoes/editar/:id" element={<Protected><TalhaoForm /></Protected>} />
              <Route path="/safras" element={<Protected><SafraList /></Protected>} />
              <Route path="/safras/create" element={<Protected><SafraForm /></Protected>} />
              <Route path="/safras/editar/:id" element={<Protected><SafraForm /></Protected>} />

              <Route path="/plantios" element={<Protected><PlantioList /></Protected>} />
              <Route path="/insumos" element={<Protected><InsumoList /></Protected>} />
              <Route path="/insumos/create" element={<Protected><InsumoForm /></Protected>} />
              <Route path="/insumos/editar/:id" element={<Protected><InsumoForm /></Protected>} />
              <Route path="/compras-insumos" element={<Protected><CompraInsumos /></Protected>} />
              <Route path="/aplicacoesinsumo" element={<Protected><AplicacaoInsumoList /></Protected>} />
              <Route path="/fluxo-plantio" element={<Protected><FluxoPlantio /></Protected>} />
              <Route path="/aplicacoesinsumo/create" element={<Protected><AplicacaoInsumoForm /></Protected>} />
              <Route path="/aplicacoesinsumo/editar/:id" element={<Protected><AplicacaoInsumoForm /></Protected>} />
              <Route path="/maquinas" element={<Protected><Maquinas /></Protected>} />
              <Route path="/operacoes-campo" element={<Protected><OperacaoCampoList /></Protected>} />
              <Route path="/operacoes-campo/create" element={<Protected><OperacaoCampoForm /></Protected>} />
              <Route path="/operacoes-campo/editar/:id" element={<Protected><OperacaoCampoForm /></Protected>} />

              <Route path="/despesa" element={<Protected><DespesaList /></Protected>} />
              <Route path="/despesa/novo" element={<Protected><LancamentoFinanceiroForm /></Protected>} />
              <Route path="/despesa/:id" element={<Protected><LancamentoFinanceiroForm /></Protected>} />
              <Route path="/financeiro/lancamento/novo" element={<Protected><LancamentoFinanceiroForm /></Protected>} />
              <Route path="/colheitas" element={<Protected><ColheitaList /></Protected>} />
              <Route path="/colheitas/create" element={<Protected><ColheitaForm /></Protected>} />
              <Route path="/colheitas/editar/:id" element={<Protected><ColheitaForm /></Protected>} />
              <Route path="/producao-agricola" element={<Protected><ProducaoAgricola /></Protected>} />
              <Route path="/producao-agricola/produtos/:id/fiscal" element={<Protected><ConfiguracaoFiscalProduto /></Protected>} />
              <Route path="/romaneio-safra" element={<Protected><RomaneioSafraList /></Protected>} />
              <Route path="/romaneio-safra/novo" element={<Protected><RomaneioSafraForm /></Protected>} />
              <Route path="/romaneio-safra/editar/:id" element={<Protected><RomaneioSafraForm /></Protected>} />

              <Route path="/receita" element={<Protected><ReceitaList /></Protected>} />
              <Route path="/receita/novo" element={<Protected><LancamentoFinanceiroForm /></Protected>} />
              <Route path="/receita/:id" element={<Protected><LancamentoFinanceiroForm /></Protected>} />
              <Route path="/contasPagarReceber" element={<Protected><ContasPagarReceber /></Protected>} />
              <Route path="/financeiro/exportacao-bancaria" element={<Protected><ExportacaoBancaria /></Protected>} />
              <Route path="/financeiro/controle-agro" element={<Protected><ControleFinanceiroAgro /></Protected>} />
              <Route path="/notas-fiscais" element={<Protected><NotaFiscalList /></Protected>} />
              <Route path="/notas-fiscais/nova" element={<Protected><NotaFiscalForm /></Protected>} />
              <Route path="/notas-fiscais/:id" element={<Protected><NotaFiscalDetalhe /></Protected>} />
              <Route path="/cte" element={<Protected><CteEmissao /></Protected>} />
              <Route path="/configuracoes/certificado" element={<Protected><CertificadoDigital /></Protected>} />
              <Route path="/assinaturas" element={<Protected><AssinaturasClientes /></Protected>} />
              <Route path="/auditoria" element={<Protected><Auditoria /></Protected>} />
              <Route path="/novidades" element={<Protected><Novidades /></Protected>} />
              <Route path="/novidades-admin" element={<Protected><NovidadesAdmin /></Protected>} />
              <Route path="/ferramentas-gestao" element={<Protected><FerramentasGestao /></Protected>} />
              <Route path="/importacao-dados" element={<Protected><ImportacaoDados /></Protected>} />

              <Route path="/fechamento-safra" element={<Protected><FechamentoSafra /></Protected>} />
              <Route path="/relatorios/integrado" element={<Protected><RelatorioIntegrado /></Protected>} />
              <Route path="/relatorios/financeiro" element={<Protected><RelatorioFinanceiro /></Protected>} />
              <Route path="/relatorioagricolaagricultor" element={<Protected><RelAgriAgricultor /></Protected>} />
              <Route path="/relatorioagricolapropriedade" element={<Protected><RelAgriPropriedade /></Protected>} />
              <Route path="/relatorios/operacoes-campo" element={<Protected><RelOperacaoCampo /></Protected>} />
              <Route path="/relatorios/colheita" element={<Protected><RelColheita /></Protected>} />
              <Route path="/relatorios/aplicacoes" element={<Protected><RelAplicacaoInsumo /></Protected>} />

              <Route path="/pecuaria" element={<Protected><PecuariaDashboard /></Protected>} />

              <Route path="/" element={<Navigate to="/menu" replace />} />
              <Route path="*" element={<Navigate to="/menu" replace />} />
            </Routes>
            <AtualizacoesModal />
            <AssistenteIa />
          </BrowserRouter>
          </ModuleProvider>
        </TenantProvider>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
